var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"overlay-card overflow-hidden",on:{"click":_vm.popUpFunction}},[[_c('img',{staticClass:"responsive",attrs:{"src":_vm.media.img,"alt":"user-profile-cover"}}),_c('div',{staticClass:"card-overlay text-white flex flex-col justify-between"},[_c('h4',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.text))])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }